import React, { useState } from 'react';
import { DashboardWidget, WidgetScopeControl } from './DashboardWidgets';
import { TIME_SCOPES } from './timeScopes';
import { useScopedStatistics } from './useScopedStatistics';

// DJB-147: Top-25 tracks leaderboard from the DJB-146 endpoint, re-queried
// whenever the time scope changes. The backend returns
// [{trackId, title, artistName, playCount}] ordered by plays desc.
export const TopTracksWidget = () => {
  const [scope, setScope] = useState('7d');
  const { data, loading, error } = useScopedStatistics('/statistics/tracks/top-played?limit=25', scope);
  const tracks = data || [];

  return (
    <DashboardWidget
      title="Top 25 Tracks"
      variant="long"
      className="top-tracks-widget"
      // DJB-169: the time scope sits top-right in the title bar
      actions={
        <WidgetScopeControl
          label="Top tracks time scope"
          options={TIME_SCOPES}
          value={scope}
          onChange={setScope}
        />
      }
    >
      {error ? (
        <div className="widget-empty-note">Top tracks are unavailable right now.</div>
      ) : loading ? (
        <div className="widget-empty-note">Loading…</div>
      ) : tracks.length === 0 ? (
        <div className="widget-empty-note">No plays in this period.</div>
      ) : (
        <ol className="widget-rows top-tracks-list">
          {tracks.map((track, index) => (
            <li key={track.trackId || index} className="widget-row top-track-row">
              <span className="top-track-rank">{index + 1}</span>
              <span className="widget-row-name">
                {track.title}
                {track.artistName && (
                  <span className="top-track-artist"> — {track.artistName}</span>
                )}
              </span>
              <span className="widget-row-value">
                {track.playCount} <span className="widget-pct">plays</span>
              </span>
            </li>
          ))}
        </ol>
      )}
    </DashboardWidget>
  );
};

export default TopTracksWidget;
